module.exports = __webpack_public_path__ + "static/media/car-2.5a7987eb.jpg";